import React, { useContext } from "react";
import HeaderSection from "./HeaderSection";
import OverviewSection from "./OverviewSection";
// import IDCardSection from './IDCardSection';
import FooterSection from "./FooterSection";
import "./HouseholdThankYou.css";
import {
  DriverHHMContextComp,
  useDriverHHM,
} from "../HouseholdContext/DriverHHMContext";
import { AddressChangeContext } from "components/StraightThroughAddressComp/AddressContext/AddressChangeContext";
import { HouseholdChangeContext } from "../HouseholdContext/HouseholdChangeContext";
import IDCardSection from "./IDCardSection";

const HouseholdThankYou = () => {
  var screen = window.location.pathname.split("/").pop();
  
  var requestContext = screen?.includes("address")
    ? AddressChangeContext
    : HouseholdChangeContext;

  var endorsementType = screen?.includes("address")
    ? "Change Address"
    : "Change Household";

  var { getTodaysDate } = useContext(requestContext);
  const currentDate = getTodaysDate();

  // console.log("Current Date", currentDate);

  return (
    <DriverHHMContextComp>
    <div className="household-thank-you">
      <HeaderSection currentDate={currentDate} />
      <OverviewSection requestContext={requestContext} endorsementType={endorsementType}/>
      {screen?.includes("address") && <IDCardSection requestContext={requestContext} endorsementType={endorsementType} />}
      <FooterSection />
    </div>
    </DriverHHMContextComp>
  );
};

export default HouseholdThankYou;
